import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { CuriosityNamespaceType, CuriosityTranslation, CuriosityValue } from '@procureai/curiosity-ui-mui';
import { identity } from 'ramda';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { SupplierEntity } from '~/components/SupplierAutocomplete';

interface SupplierSourceReferenceCellProps<R extends GridValidRowModel = any> {
  row: R;
  supplierId: string | null | undefined;
  supplierExternalReference: string | null | undefined;
}

export const SupplierSourceReferenceCell = <R extends GridValidRowModel = any>({
  supplierId,
  supplierExternalReference,
}: SupplierSourceReferenceCellProps<R>) => {
  if (!supplierId) {
    return <>{supplierExternalReference ?? NULLISH_CELL_VALUE}</>;
  }

  return (
    <CuriosityValue ns={CuriosityNamespaceType.SUPPLIER} i18nKey={supplierId} valueGetter={identity}>
      {(curiosityValue) => {
        const sourceReference = (curiosityValue as CuriosityTranslation<SupplierEntity>).entity?.sourceReference;
        return <>{sourceReference ?? supplierExternalReference ?? NULLISH_CELL_VALUE}</>;
      }}
    </CuriosityValue>
  );
};
